import React from 'react';
import { ServicesSection, WhyChooseUs, TestimonialsSection, CTASection } from '../components/Sections';
import FooterSection from '../components/Footer';

const ServicesPage = ({ isDark }) => (
  <>
    <section className={`relative py-32 transition-colors duration-300 ${isDark ? 'bg-[#0a0a0a]' : 'bg-gray-900'}`}>
      <div className={`absolute inset-0 ${isDark ? 'bg-gradient-to-b from-[#1a1a1a] to-[#0a0a0a]' : 'bg-gradient-to-b from-gray-800 to-gray-900'}`}></div>
      <div className="relative z-10 container-custom text-center">
        <h1 className="text-5xl md:text-6xl font-bold mb-4 text-white">Our <span className="text-[#c9a962]">Services</span></h1>
        <p className="text-xl text-gray-400">Premium car rental services tailored to your needs</p>
      </div>
    </section>
    <ServicesSection isDark={isDark} />
    <WhyChooseUs isDark={isDark} />
    <TestimonialsSection isDark={isDark} />
    <CTASection isDark={isDark} />
    <FooterSection isDark={isDark} />
  </>
);

export default ServicesPage;
